import { service } from '@ember/service';
import ApplicationAdapter from './application';
import classic from 'ember-classic-decorator';

@classic
export default class InsuranceTextExtraction extends ApplicationAdapter {
  @service fileUpload;

  async extractInsuranceCardInfoFromDocument(documentId) {
    let baseUrl = `${this.buildURL(
      'insurance-text-extraction'
    )}/extract-insurance-card-info-from-document`;
    let payload = await this.ajax(baseUrl, 'POST', { data: { documentId } });

    this.store.pushPayload(payload);
    return payload;
  }

  async extractInsuranceCardInfoFromFile(file, data) {
    let payload = await this.fileUpload.uploadTask.perform(file, {
      route: this.urlForExtractInsuranceCardInfo(),
      headers: this.headers,
      fileKey: 'file',
      data,
    });

    return payload;
  }

  urlForExtractInsuranceCardInfo() {
    return `${this.buildURL('insurance-text-extraction')}/extract-insurance-card-info-from-file`;
  }
}
